import { UserAccountsInfo, WalletData } from '../typings/common';
import {
    HeaderInfoBlockData,
    HeaderInfoBlockNewsItemData,
    HeaderInfoData
} from '../typings/header';

export const FETCH_INFO_BLOCK_DATA = 'FETCH_INFO_BLOCK_DATA';
export type FETCH_INFO_BLOCK_DATA = typeof FETCH_INFO_BLOCK_DATA;

export interface FetchInfoBlockData {
    type: FETCH_INFO_BLOCK_DATA;
}

export function fetchInfoBlockData(): FetchInfoBlockData {
    return {
        type: FETCH_INFO_BLOCK_DATA
    };
}

export const FETCH_NEXT_INFO_BLOCK_NEWS_ITEM =
    'FETCH_NEXT_INFO_BLOCK_NEWS_ITEM';
export type FETCH_NEXT_INFO_BLOCK_NEWS_ITEM = typeof FETCH_NEXT_INFO_BLOCK_NEWS_ITEM;

export interface FetchNextInfoBlockNewsItem {
    type: FETCH_NEXT_INFO_BLOCK_NEWS_ITEM;
}

export function fetchNextInfoBlockNewsItem(): FetchNextInfoBlockNewsItem {
    return {
        type: FETCH_NEXT_INFO_BLOCK_NEWS_ITEM
    };
}

export const UPDATE_INFO_BLOCK_DATA = 'UPDATE_INFO_BLOCK_DATA';
export type UPDATE_INFO_BLOCK_DATA = typeof UPDATE_INFO_BLOCK_DATA;

export interface UpdateInfoBlockData {
    type: UPDATE_INFO_BLOCK_DATA;
    newsData: HeaderInfoBlockData;
}

export function updateInfoBlockData(
    newsData: HeaderInfoBlockData
): UpdateInfoBlockData {
    return {
        type: UPDATE_INFO_BLOCK_DATA,
        newsData
    };
}

export const UPDATE_INFO_BLOCK_NEWS_DATA = 'UPDATE_INFO_BLOCK_NEWS_DATA';
export type UPDATE_INFO_BLOCK_NEWS_DATA = typeof UPDATE_INFO_BLOCK_NEWS_DATA;

export interface UpdateInfoBlockNewsData {
    type: UPDATE_INFO_BLOCK_NEWS_DATA;
    newsDataItem: HeaderInfoBlockNewsItemData;
}

export function updateInfoBlockNewsData(
    newsDataItem: HeaderInfoBlockNewsItemData
): UpdateInfoBlockNewsData {
    return {
        type: UPDATE_INFO_BLOCK_NEWS_DATA,
        newsDataItem
    };
}

export const SET_INFO_BLOCK_NEWS_ERROR = 'SET_INFO_BLOCK_NEWS_ERROR';
export type SET_INFO_BLOCK_NEWS_ERROR = typeof SET_INFO_BLOCK_NEWS_ERROR;

export interface SetInfoBlockNewsError {
    type: SET_INFO_BLOCK_NEWS_ERROR;
    error: string;
}

export function setInfoBlockNewsError(error: string): SetInfoBlockNewsError {
    return {
        type: SET_INFO_BLOCK_NEWS_ERROR,
        error
    };
}

export const SEND_GRID_FEEDBACK = 'SEND_FEEDBACK';
export type SEND_GRID_FEEDBACK = typeof SEND_GRID_FEEDBACK;

export interface SendGridFeedback {
    type: SEND_GRID_FEEDBACK;
    message: string;
}

export function sendGridFeedback(message: string): SendGridFeedback {
    return {
        type: SEND_GRID_FEEDBACK,
        message
    };
}

export const FETCH_USER_ACCOUNTS_INFO = 'FETCH_USER_ACCOUNTS_INFO';
export type FETCH_USER_ACCOUNTS_INFO = typeof FETCH_USER_ACCOUNTS_INFO;

export interface FetchUserAccountsInfo {
    type: FETCH_USER_ACCOUNTS_INFO;
}

export function fetchUserAccountsInfo(): FetchUserAccountsInfo {
    return {
        type: FETCH_USER_ACCOUNTS_INFO
    };
}

export const UPDATE_USER_ACCOUNTS_INFO = 'UPDATE_USER_ACCOUNTS_INFO';
export type UPDATE_USER_ACCOUNTS_INFO = typeof UPDATE_USER_ACCOUNTS_INFO;

export interface UpdateUserAccountsInfo {
    type: UPDATE_USER_ACCOUNTS_INFO;
    accountsInfo: UserAccountsInfo;
}

export function updateUserAccountsInfo(
    accountsInfo: UserAccountsInfo
): UpdateUserAccountsInfo {
    return {
        type: UPDATE_USER_ACCOUNTS_INFO,
        accountsInfo
    };
}

export const SET_USER_ACCOUNTS_INFO_FETCH_ERROR =
    'SET_USER_ACCOUNTS_INFO_FETCH_ERROR';
export type SET_USER_ACCOUNTS_INFO_FETCH_ERROR = typeof SET_USER_ACCOUNTS_INFO_FETCH_ERROR;

export interface SetUserAccountsInfoFetchError {
    type: SET_USER_ACCOUNTS_INFO_FETCH_ERROR;
}

export function setUserAccountsInfoFetchError(): SetUserAccountsInfoFetchError {
    return {
        type: SET_USER_ACCOUNTS_INFO_FETCH_ERROR
    };
}

export const FETCH_HEADER_INFO = 'FETCH_HEADER_INFO';
export type FETCH_HEADER_INFO = typeof FETCH_HEADER_INFO;

export interface FetchHeaderInfo {
    type: FETCH_HEADER_INFO;
}

export function fetchHeaderInfo(): FetchHeaderInfo {
    return {
        type: FETCH_HEADER_INFO
    };
}

export const UPDATE_HEADER_INFO = 'UPDATE_HEADER_INFO';
export type UPDATE_HEADER_INFO = typeof UPDATE_HEADER_INFO;

export interface UpdateHeaderInfo {
    type: UPDATE_HEADER_INFO;
    data: HeaderInfoData;
}

export function updateHeaderInfo(data: HeaderInfoData): UpdateHeaderInfo {
    return {
        type: UPDATE_HEADER_INFO,
        data
    };
}

export const SET_UNAUTHORIZED_HEADER_DATA = 'SET_UNAUTHORIZED_HEADER_DATA';
export type SET_UNAUTHORIZED_HEADER_DATA = typeof SET_UNAUTHORIZED_HEADER_DATA;

export interface SetUnauthorizedHeaderData {
    type: SET_UNAUTHORIZED_HEADER_DATA;
}

export function setUnauthorizedHeaderData(): SetUnauthorizedHeaderData {
    return {
        type: SET_UNAUTHORIZED_HEADER_DATA
    };
}

export const FIRE_COMMON_WALLET_CLICK = 'FIRE_COMMON_WALLET_CLICK';
export type FIRE_COMMON_WALLET_CLICK = typeof FIRE_COMMON_WALLET_CLICK;

export interface FireCommonWalletClick {
    type: FIRE_COMMON_WALLET_CLICK;
}

export function fireCommonWalletClick(): FireCommonWalletClick {
    return {
        type: FIRE_COMMON_WALLET_CLICK
    };
}

export const FETCH_HEADER_WALLET_INFO = 'FETCH_HEADER_WALLET_INFO';
export type FETCH_HEADER_WALLET_INFO = typeof FETCH_HEADER_WALLET_INFO;

export interface FetchHeaderWalletInfo {
    type: FETCH_HEADER_WALLET_INFO;
}

export function fetchHeaderWalletInfo(): FetchHeaderWalletInfo {
    return {
        type: FETCH_HEADER_WALLET_INFO
    };
}

export const SET_HEADER_WALLET_INFO = 'SET_HEADER_WALLET_INFO';
export type SET_HEADER_WALLET_INFO = typeof SET_HEADER_WALLET_INFO;

export interface SetHeaderWalletInfo {
    type: SET_HEADER_WALLET_INFO;
    wallet: WalletData;
}

export function setHeaderWalletInfo(wallet: WalletData): SetHeaderWalletInfo {
    return {
        type: SET_HEADER_WALLET_INFO,
        wallet
    };
}

export type HeaderAction =
    | FireCommonWalletClick
    | FetchInfoBlockData
    | FetchHeaderWalletInfo
    | SetHeaderWalletInfo
    | FetchNextInfoBlockNewsItem
    | UpdateInfoBlockData
    | SendGridFeedback
    | SetUserAccountsInfoFetchError
    | UpdateUserAccountsInfo
    | FetchUserAccountsInfo
    | SetUnauthorizedHeaderData
    | SetInfoBlockNewsError
    | FetchHeaderInfo
    | UpdateHeaderInfo
    | UpdateInfoBlockNewsData;
